"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConfig = exports.default = void 0;
const getConfig = () => window.icisHeader.config;
exports.getConfig = getConfig;
var _default = exports.default = getConfig;